import { render, staticRenderFns } from "./customerAddressSelection.vue?vue&type=template&id=176549d4&scoped=true&"
import script from "./customerAddressSelection.vue?vue&type=script&lang=js&"
export * from "./customerAddressSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176549d4",
  null
  
)

export default component.exports